import { useCallback } from "react";
import {navigateHook} from "./use-navigate.js";


export function useFormNavigation(path) {
    const navigate = navigateHook();

    const onRowClicked = useCallback(
        (event) => {
            const id = event?.data?.id;
            if (!id) return;

          const isCtrlPressed = event.event.ctrlKey || event.event.metaKey;

          if(isCtrlPressed){
            navigate(`${path.edit.dev}/${id}`, true);
          } else {
            navigate(`${path.edit.dev}/${id}`, path.create.isBlank);
          }
        },
        [navigate, path]
    );

    const openForm = useCallback(
        () => {
            navigate(path.create.dev, path.create.isBlank);
        },
        [navigate, path]
    );

    return { onRowClicked, openForm };
}
